import React from 'react'
import { FormControl, Input } from '@fortressiq/fiq-ds'

import { useRegisterField } from './hooks'

import { inputStyle } from '../../styles'

const TextInput = ({
  defaultValue,
  description,
  errors,
  handleChange,
  inputName,
  label,
  noMargin,
  placeholder,
  register,
  unregister,
  validate,
}) => {
  const registerInput = useRegisterField(inputName, register, unregister, validate)

  const onChangeHandler = e => {
    registerInput.onChange(e)

    handleChange(e.target.name, e.target.value)
  }
  if (!registerInput) return null

  return (
    <FormControl errors={errors} helperText={description} style={noMargin && { margin: 0 }}>
      <Input
        defaultValue={defaultValue}
        id={`application-input-${inputName}`}
        label={label}
        name={registerInput.name}
        onBlur={registerInput.onBlur}
        onChange={onChangeHandler}
        placeholder={placeholder || label}
        ref={registerInput.ref}
        style={inputStyle}
      />
    </FormControl>
  )
}

export default TextInput
